import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ScrollExpandMedia from "@/components/ScrollExpandMedia";
import Programs from "@/components/Programs";
import Testimonials from "@/components/Testimonials";
import PhotoBook from "@/components/PhotoBook";
import BookSession from "@/components/BookSession";
import Contact from "@/components/Contact";
import FAQ from "@/components/FAQ";
import WhatsAppButton from "@/components/WhatsAppButton";
import Footer from "@/components/Footer";
import wellnessBg from "@/assets/wellness-background.jpg";
import vidThumbnail from "@/assets/vid_thumbnail.jpg";
const Index = () => {
  return <>
      <Helmet>
        <link rel="canonical" href="https://renewsantulan.com/" />
        <meta property="og:url" content="https://renewsantulan.com/" />
        <meta name="twitter:url" content="https://renewsantulan.com/" />
      </Helmet>
      <main className="min-h-screen">
        <Navigation />
      <Hero />
      <ScrollExpandMedia mediaType="video" mediaSrc="/videos/nikita-story.mp4" posterSrc={vidThumbnail} bgImageSrc={wellnessBg} title="My Journey" scrollToExpand="Scroll to expand" />
      <div id="programs" className="bg-[#f7f4ed] border-[#f6f2e9]">
        <Programs />
      </div>
      <div id="testimonials">
        <Testimonials />
      </div>
      <PhotoBook />
      <div id="book-session">
        <BookSession />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <FAQ />
      
        <WhatsAppButton />
        <Footer />
      </main>
    </>;
};
export default Index;